import React from 'react'

import MicrocmsImage from '@atoms/MicrocmsImage'
import { ImageWithTextContent, isValidString } from '@models/Article'

import * as style from './style.module.sass'

type ArtisanImageWithTextProps = ImageWithTextContent & {
  isMasked: boolean
}
const ArtisanImageWithText: React.FC<ArtisanImageWithTextProps> = ({
  fieldId,
  image,
  contents,
  caption,
  isMasked,
}) => (
  <div className={style.imageWithText} data-field-id={fieldId}>
    {fieldId === 'rightImage' && (
      <div dangerouslySetInnerHTML={{ __html: contents }} />
    )}
    <div className={style.imageContainer} data-fixed={isMasked}>
      <MicrocmsImage
        image={image}
        alt={isValidString(caption) ? caption : ''}
        type="hero"
      />
      {isValidString(caption) && (
        <figcaption
          className={style.caption}
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      )}
    </div>
    {fieldId === 'leftImage' && (
      <div dangerouslySetInnerHTML={{ __html: contents }} />
    )}
  </div>
)

export default ArtisanImageWithText
